import Vue from 'vue';
import Router from 'vue-router';

import globalStore, {globalStoreMethods} from './global-store'
import loginStore from './modules/login/store';

import loginRoutes from './modules/login/router';
import rootRoutes from './modules/root/router';
import securityRoutes from './modules/security/router';
import designRoutes from './modules/design/router';
import searchRoutes from './modules/search/router';
import newsRoutes from './modules/news/router';
import translationRoutes from './modules/translation/router';
import channelsRoutes from './modules/channels/router';
import globalLanguages from './global-languages';



Vue.use(Router);


const globalRouter = new Router({
    //mode: 'history',
    //base: process.env.BASE_URL + 'login',

    routes: [


        // associazione routes definite per le diverse sezioni
        ...rootRoutes,
        ...loginRoutes,
        ...securityRoutes,
        ...designRoutes,
        ...searchRoutes,
        ...newsRoutes,
        ...translationRoutes,
        ...channelsRoutes,

        // home page
        {
            path: '/',
            redirect: '/dashboard'
        },

        // dichiarazione route per autorizzazione fallita
        {
            path: '/forbidden',
            name: 'error-forbidden',
            component: () => import('./error-forbidden'),
            meta: {layout: 'layout-empty'}
        },

        // arrivato qui non posso fare molto
        {
            path: '*',
            name: 'error-not-found',
            component: () => import('./error-not-found'),
            meta: {layout: 'layout-empty'}
        }
    ]
});

// metodo chiamato prima di ogni cambio route
globalRouter.beforeEach((to, from, next) => {
    const loggedUser = globalStore.state.loggedUser;
    // verifico autenticazione
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if(requiresAuth && !loggedUser) {

        // sparo alla pagina di login
        next('/login');

    } else {
        if(to.name === 'dashboard') //gestione homepage
        {
            next({name: loginStore.actions.getRouteName({rootState: globalStore.state},loggedUser)});
        }

        // applico il layout previsto dalla view
        if(to.matched.length>0){
            const layout = to.matched[0].meta.layout;
            globalStore.commit(globalStoreMethods.mutations.setLayout, layout);
            if(to.meta.title) {
                document.title = globalLanguages.t(to.meta.title);
            }
        }

        // avanzo
        next();
    }

});


export default globalRouter;